import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPicker, Input } from "uxp/components";
import { applyAtPath, findAvailableFields, IUIPropertyDefinition } from "../../../common/common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bindContainerId } from "../../../../util";

export interface IBoxChartProps {
    labelField: string,
    valueField: string,
    legend: boolean,
    colors: string[],
    refreshInsterval: number,
    channel?: string,
    useColorsForLabels: boolean,
    shadow: boolean,
    barHeight:number,
    borderRadius:number,
}


export function BoxChartProperty(title: string, props: IBoxChartProps): IUIPropertyDefinition<IBoxChartProps> {
    return {
        defaults: props,
        render: (props, uxpContext, data, containerId) => {

            let _props = props.uiProps

            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();

            return <PropertyContainer>
                <PropertyContainerTitle>{title}</PropertyContainerTitle>
                <PropertyGroup>
                    <Property id={bindContainerId('value-field', containerId)}>
                        <PropertyTitle>Value Field</PropertyTitle>
                        <AutoCompleteInput
                            value={_props.valueField || ''}
                            onChange={s => {
                                jp.apply(_props, '$.valueField', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            options={pv}
                        />

                    </Property>

                    <Property id={bindContainerId('label-field', containerId)}>
                        <PropertyTitle>Label Field</PropertyTitle>
                        <AutoCompleteInput
                            value={_props.labelField || ''}
                            onChange={s => {
                                jp.apply(_props, '$.labelField', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            options={pv}
                        />

                    </Property>

                    <Property>
                        <Checkbox
                            checked={_props?.legend}
                            onChange={s => {
                                jp.apply(_props, '$.legend', () => (s))
                                props.onChange(_props)
                            }}
                            label="Show Legend"
                        />

                    </Property>
                    <Property>
                        <Checkbox
                            checked={!!_props?.useColorsForLabels}
                            onChange={s => {
                                let p = applyAtPath(_props, '$.useColorsForLabels', () => (s))
                                props.onChange(p)
                            }}
                            label="Use colored labels"
                        />

                    </Property>
                    <Property>
                        <Checkbox
                            checked={_props?.shadow}
                            onChange={s => {
                                jp.apply(_props, '$.shadow', () => (s))
                                props.onChange(_props)
                            }}
                            label="Add Shadows"
                        />

                    </Property>
                    <Property>
                    <PropertyTitle>Bar Height</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.barHeight?.toString() || '100'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.barHeight', () => (num))
                                props.onChange(_props)
                            }}
                        />


                    </Property>
                    <Property>
                    <PropertyTitle>Curve Edges</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.borderRadius?.toString() || '5'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.borderRadius', () => (num))
                                props.onChange(_props)
                            }}
                        />


                    </Property>
                    <Property>
                        <PropertyTitle>Refresh Interval (ms)</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.refreshInsterval?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.refreshInsterval', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>

                    <Property>
                        <PropertyTitle>Channel Name</PropertyTitle>
                        <Input
                            value={_props?.channel || ''}
                            onChange={s => {
                                jp.apply(_props, '$.channel', () => (s))
                                props.onChange(_props)
                            }}
                        />

                    </Property>

                </PropertyGroup>

                <PropertyGroup>
                    <div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Colors

                        <div className="plus" style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '14px',
                            cursor: 'pointer'
                        }}
                            onClick={() => {

                                let _colors = _props?.colors || []
                                _colors.unshift('')

                                jp.apply(_props, `$.colors`, () => (_colors))
                                props.onChange(_props)
                            }}
                        >
                            <FontAwesomeIcon icon={['fas', 'plus']} />
                        </div>

                    </div>

                    <Property>
                        <PropertyTitle>Colors</PropertyTitle>

                        <div className="wd-gauge-config-colors">

                            {_props?.colors?.map((s, i) => {

                                return <div className="row">
                                    <div className="color">
                                        <ColorPicker
                                            color={s}
                                            onChange={(s) => {
                                                jp.apply(_props, `$.colors[${i}]`, () => (s))
                                                props.onChange(_props)
                                            }}
                                            // className='color-input'
                                            position='right'
                                        />

                                    </div>

                                    <div className="close"
                                        onClick={() => {
                                            let _colors = _props?.colors || []
                                            _colors.splice(i, 1)

                                            jp.apply(_props, `$.colors`, () => (_colors))
                                            props.onChange(_props)
                                        }}
                                    >
                                        <FontAwesomeIcon icon={['fas', 'trash']} className='delete' />
                                    </div>
                                </div>
                            })}
                        </div>

                    </Property>

                </PropertyGroup>
            </PropertyContainer>
        }
    };
}
